//Lib 
import { mapState } from "vuex";

// Api
import api from '@/api/baseApi';

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE } from "@/constant/extraService";
import { SERVICE_TYPE } from "@/constant/rental";

// Function 
const queryString = require('query-string');

export default {

    extends: baseExtraService,

    computed: {
        issuesTypeList() {
            return this.$CommonParameter.reportIssues.map(x => ({ label: x.name, value: parseInt(x.value), description: x.description }));
        },
    },

    data() {

        return {
            dataNote: [
                {
                    label: this.$t('reportIssues.instructionsTitle'),
                    children: [
                        {
                            label: `• ${this.$t('reportIssues.noShutdownWarning')}`,
                        },
                        {
                            label: `• ${this.$t('reportIssues.emailNotification')}`,
                        },
                        {
                            label: `• ${this.$t('reportIssues.refundWithin24h')}`,
                        },
                        {
                            label: `• ${this.$t('reportIssues.leaveContactMethod')}`,
                        },
                    ]
                },
            ],
            issuesType: 6,
            // issuesTypeList: [
            //     {
            //         label: 'Unable to connect',
            //         value: 1
            //     },
            //     {
            //         label: 'Black screen',
            //         value: 2
            //     },
            //     {
            //         label: "Can't connect Z drive",
            //         value: 3
            //     },
            //     {
            //         label: 'No data found on Z drive',
            //         value: 4
            //     },
            //     {
            //         label: 'Other',
            //         value: 5
            //     },
            // ],
            note: null,
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.EXTRA_SERVICE_REPORT_ISSUES);
        },
        //#endregion 

        goUrl() {
            window.open(this.issuesTypeList.find((x) => x.value === this.issuesType).description, '_blank');
        },

        sendAndChat() {
            this.send();
            if(window.chatTool ==="chatwood") window.$chatwoot.toggle("open");
        },

        //#region Expand image threshold send request
        send() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: EXTRA_SERVICE_TYPE.REPORT_ISSUES,
                    machineId: this.targetImage.id,
                    issuesType: this.issuesType,
                    note: this.note,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.createRequest(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}